
import { Vue } from "vue-property-decorator";
import _ from "lodash";

import { AccountService } from "@/core/services";

export default class AppVue extends Vue {
  notify(title: string, message: string, type: any) {
    this.$notify({
      title,
      message,
      type,
    });
  }

  get currentUserId() {
    return parseInt(this.$auth.getPayload().userId, 10);
  }

  get isAdmin() {
    return AccountService.isAdmin();
  }

  get isUser() {
    return AccountService.isUser();
  }

  get isDovetail() {
    return AccountService.isDovetail();
  }

  get isImi() {
    return AccountService.isImi();
  }

  get isEi() {
    return AccountService.isEi();
  }

  get environment() {
    return process.env.VUE_APP_ENVIRONMENT;
  }

  get isDevEnv() {
    return this.environment === "Dev";
  }

  get isTestEnv() {
    return this.environment === "Test";
  }

  get isProdEnv() {
    // "Build" is really just the Justice Dept env, but in Octopus it's being
    // deployed in the "Build" track, to not create a full new one
    return this.environment === "Build" || this.environment === "Production";
  }

  private isInRole(roleName: string) {
    return AccountService.isInRole(roleName);
  }
}
